// [ai] The pieces every frame body shares: the error card, the first-paint reporter and the per-frame ErrorBoundary.
import { Component, useEffect, type ReactNode } from "react";
export const ErrorCard = ({ text }: { text: string }) => <div className="at-widget-err" role="alert">{text}</div>;
/** Reports the first commit of what renders beside it (a catalog widget's or a module's first paint) — a passive effect, after the frame's layout-effect registration. */
export function Rendered({ onReady }: { onReady: () => void }) { useEffect(() => { onReady(); }, [onReady]); return null; }
export class Boundary extends Component<{ onError: (msg: string) => void; children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  override componentDidCatch(e: Error) { this.props.onError(e.message || String(e)); }
  override render() { return this.state.failed ? null : this.props.children; }
}
